export default __webpack_public_path__ + "static/media/kyc-light.32e06b74.svg";